import { IPagination, ISearch } from "../../data/AppInterface";
import { TReactSetState, TSetPaginationFn } from "../../data/AppType";
import { IEvent } from "../../screens/header/home-page/HomePageController";
import { GET_EVENTS } from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  generatePaginationFromApiRes,
  resetPaginationWithPpr,
  toastError,
} from "../../utils/AppFunctions";

export const fetchEvents = async (
  setEventList: TReactSetState<IEvent[]>,
  setPagination: TSetPaginationFn,
  pagination: IPagination,
  events: IEvent[],
  setLoading: TReactSetState<boolean>,
  setBuffer: TReactSetState<boolean>,
  search: ISearch,
  append: boolean
) => {
  try {
    setLoading(true);
    setBuffer(true);
    const eventList = await GET_EVENTS(pagination, search);

    if (eventList && eventList.code === DEFAULT_STATUS_CODE_SUCCESS) {
      if (append) {
        setEventList([...events, ...eventList?.data?.item]);
      } else setEventList(eventList?.data?.item);
      setPagination({
        ...pagination,
        ...generatePaginationFromApiRes(eventList.data.pagination),
      });
    } else {
      setEventList([]);
      setPagination({
        ...pagination,
        ...resetPaginationWithPpr(pagination.per_page_rows),
      });
    }
  } catch (error: any) {
    toastError(error?.eventList.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
  } finally {
    setLoading(false);
    setBuffer(false);
  }
};
